<template>
  <div class="join-container">
    <!-- 使用公共导航栏组件 -->
    <Nav />

   <!-- 主要内容区域 -->
     <section class="pt-20 bg-gradient-to-br from-blue-50 to-white">
    <div class="max-w-7xl mx-auto px-6 lg:px-12 py-16">
      <div class="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        <div>
          <h1 class="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">加入我们，共创会展未来</h1>
          <p class="text-lg text-gray-600 mb-8">成为我们的供应商合作伙伴，共享亿级市场机遇</p>
          <div class="flex flex-wrap gap-4">
            <button
              class="bg-primary text-white px-8 py-3 !rounded-button hover:bg-secondary transition-colors text-lg whitespace-nowrap">立即加盟</button>
            <button
              class="border-2 border-primary text-primary px-8 py-3 !rounded-button hover:bg-primary hover:text-white transition-colors text-lg whitespace-nowrap">了解更多</button>
          </div>
          <div class="grid grid-cols-3 gap-8 mt-12">
            <div class="text-center">
              <div class="text-3xl font-bold text-primary mb-2">1000+</div>
              <p class="text-gray-600">合作供应商</p>
            </div>
            <div class="text-center">
              <div class="text-3xl font-bold text-primary mb-2">50+</div>
              <p class="text-gray-600">城市覆盖</p>
            </div>
            <div class="text-center">
              <div class="text-3xl font-bold text-primary mb-2">98%</div>
              <p class="text-gray-600">好评率</p>
            </div>
          </div>
        </div>
        <div class="relative">
          <img
            src="https://readdy.ai/api/search-image?query=Professional%20exhibition%20equipment%20supplier%20partnership%2C%20modern%20business%20collaboration%20concept%2C%20clean%20corporate%20style%20with%20light%20background%20that%20matches%20the%20left%20side%20text%20area&width=600&height=400&seq=hero&orientation=landscape"
            alt="供应商加盟" class="w-full rounded-xl shadow-lg">
          <div class="absolute -bottom-6 -right-6 bg-white p-4 rounded-xl shadow-lg">
            <div class="flex items-center space-x-2">
              <div class="w-10 h-10 bg-blue-50 rounded-full flex items-center justify-center">
                <i class="ri-shield-check-line text-xl text-primary"></i>
              </div>
              <div>
                <div class="text-sm font-medium text-gray-900">平台认证</div>
                <div class="text-xs text-gray-500">品质保障</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="py-16 px-6 lg:px-12">
    <div class="max-w-7xl mx-auto">
      <div class="text-center mb-12">
        <h2 class="text-3xl font-bold text-gray-900 mb-4">加盟优势</h2>
        <p class="text-gray-600 text-lg">为什么选择我们？专业的平台助您业务腾飞</p>
      </div>
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
        <div class="bg-white p-8 rounded-xl shadow-sm hover:shadow-lg transition-shadow">
          <div class="w-14 h-14 bg-blue-50 rounded-xl flex items-center justify-center mb-6">
            <i class="ri-line-chart-line text-2xl text-primary"></i>
          </div>
          <h3 class="text-xl font-semibold text-gray-900 mb-4">流量优势</h3>
          <p class="text-gray-600">平台日均访问量 10w+，为您带来源源不断的优质客户</p>
        </div>
        <div class="bg-white p-8 rounded-xl shadow-sm hover:shadow-lg transition-shadow">
          <div class="w-14 h-14 bg-blue-50 rounded-xl flex items-center justify-center mb-6">
            <i class="ri-megaphone-line text-2xl text-primary"></i>
          </div>
          <h3 class="text-xl font-semibold text-gray-900 mb-4">营销支持</h3>
          <p class="text-gray-600">专业的营销团队，帮助您打造品牌影响力</p>
        </div>
        <div class="bg-white p-8 rounded-xl shadow-sm hover:shadow-lg transition-shadow">
          <div class="w-14 h-14 bg-blue-50 rounded-xl flex items-center justify-center mb-6">
            <i class="ri-tools-line text-2xl text-primary"></i>
          </div>
          <h3 class="text-xl font-semibold text-gray-900 mb-4">运营支持</h3>
          <p class="text-gray-600">一站式运营服务，助您高效管理业务</p>
        </div>
        <div class="bg-white p-8 rounded-xl shadow-sm hover:shadow-lg transition-shadow">
          <div class="w-14 h-14 bg-blue-50 rounded-xl flex items-center justify-center mb-6">
            <i class="ri-secure-payment-line text-2xl text-primary"></i>
          </div>
          <h3 class="text-xl font-semibold text-gray-900 mb-4">资金保障</h3>
          <p class="text-gray-600">专业的资金结算系统，确保交易安全</p>
        </div>
      </div>
    </div>
  </section>

  <section class="py-16 px-6 lg:px-12 bg-gray-50">
    <div class="max-w-7xl mx-auto">
      <div class="text-center mb-12">
        <h2 class="text-3xl font-bold text-gray-900 mb-4">加盟条件</h2>
        <p class="text-gray-600 text-lg">严格的准入标准，确保服务品质</p>
      </div>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div class="bg-white p-8 rounded-xl shadow-sm">
          <h3 class="text-xl font-semibold text-gray-900 mb-6">基本要求</h3>
          <ul class="space-y-4">
            <li class="flex items-start">
              <div class="w-5 h-5 flex items-center justify-center mt-0.5 mr-3">
                <i class="ri-check-line text-green-500"></i>
              </div>
              <div>
                <h4 class="font-medium text-gray-900 mb-1">企业资质</h4>
                <p class="text-gray-600 text-sm">具有独立法人资格，注册资金不低于 100 万元</p>
              </div>
            </li>
            <li class="flex items-start">
              <div class="w-5 h-5 flex items-center justify-center mt-0.5 mr-3">
                <i class="ri-check-line text-green-500"></i>
              </div>
              <div>
                <h4 class="font-medium text-gray-900 mb-1">经营年限</h4>
                <p class="text-gray-600 text-sm">从事相关行业 2 年以上，具有良好的市场信誉</p>
              </div>
            </li>
            <li class="flex items-start">
              <div class="w-5 h-5 flex items-center justify-center mt-0.5 mr-3">
                <i class="ri-check-line text-green-500"></i>
              </div>
              <div>
                <h4 class="font-medium text-gray-900 mb-1">团队要求</h4>
                <p class="text-gray-600 text-sm">拥有专业的运营团队和技术支持人员</p>
              </div>
            </li>
          </ul>
        </div>
        <div class="bg-white p-8 rounded-xl shadow-sm">
          <h3 class="text-xl font-semibold text-gray-900 mb-6">设备要求</h3>
          <ul class="space-y-4">
            <li class="flex items-start">
              <div class="w-5 h-5 flex items-center justify-center mt-0.5 mr-3">
                <i class="ri-check-line text-green-500"></i>
              </div>
              <div>
                <h4 class="font-medium text-gray-900 mb-1">设备品质</h4>
                <p class="text-gray-600 text-sm">设备需为原厂正品，具备完整的质量认证</p>
              </div>
            </li>
            <li class="flex items-start">
              <div class="w-5 h-5 flex items-center justify-center mt-0.5 mr-3">
                <i class="ri-check-line text-green-500"></i>
              </div>
              <div>
                <h4 class="font-medium text-gray-900 mb-1">库存要求</h4>
                <p class="text-gray-600 text-sm">具备充足的设备库存，确保及时供应</p>
              </div>
            </li>
            <li class="flex items-start">
              <div class="w-5 h-5 flex items-center justify-center mt-0.5 mr-3">
                <i class="ri-check-line text-green-500"></i>
              </div>
              <div>
                <h4 class="font-medium text-gray-900 mb-1">维护保养</h4>
                <p class="text-gray-600 text-sm">具备专业的设备维护和保养能力</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>

  <section class="py-16 px-6 lg:px-12">
    <div class="max-w-7xl mx-auto">
      <div class="text-center mb-12">
        <h2 class="text-3xl font-bold text-gray-900 mb-4">加盟流程</h2>
        <p class="text-gray-600 text-lg">简单四步，开启合作之旅</p>
      </div>
      <div class="relative">
        <div class="hidden  absolute top-32 left-0 right-0 h-0.5 bg-gray-200"></div>
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div class="relative">
            <div class="flex flex-col items-center">
              <div
                class="w-16 h-16 bg-primary text-white rounded-full flex items-center justify-center text-xl font-bold relative z-10">
                01</div>
              <div class="mt-6 text-center">
                <h3 class="text-lg font-semibold text-gray-900 mb-2">提交申请</h3>
                <p class="text-sm text-gray-600">填写基本信息，提交加盟申请</p>
              </div>
            </div>
          </div>
          <div class="relative">
            <div class="flex flex-col items-center">
              <div
                class="w-16 h-16 bg-primary text-white rounded-full flex items-center justify-center text-xl font-bold relative z-10">
                02</div>
              <div class="mt-6 text-center">
                <h3 class="text-lg font-semibold text-gray-900 mb-2">资质审核</h3>
                <p class="text-sm text-gray-600">平台审核企业资质和设备情况</p>
              </div>
            </div>
          </div>
          <div class="relative">
            <div class="flex flex-col items-center">
              <div
                class="w-16 h-16 bg-primary text-white rounded-full flex items-center justify-center text-xl font-bold relative z-10">
                03</div>
              <div class="mt-6 text-center">
                <h3 class="text-lg font-semibold text-gray-900 mb-2">签约合作</h3>
                <p class="text-sm text-gray-600">签订合作协议，确定合作细节</p>
              </div>
            </div>
          </div>
          <div class="relative">
            <div class="flex flex-col items-center">
              <div
                class="w-16 h-16 bg-primary text-white rounded-full flex items-center justify-center text-xl font-bold relative z-10">
                04</div>
              <div class="mt-6 text-center">
                <h3 class="text-lg font-semibold text-gray-900 mb-2">正式运营</h3>
                <p class="text-sm text-gray-600">完成系统对接，开始正式运营</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="py-16 px-6 lg:px-12 bg-gray-50">
    <div class="max-w-7xl mx-auto">
      <div class="text-center mb-12">
        <h2 class="text-3xl font-bold text-gray-900 mb-4">在线申请</h2>
        <p class="text-gray-600 text-lg">填写以下信息，我们将尽快与您联系</p>
      </div>
      <div class="max-w-2xl mx-auto">
        <form class="space-y-6">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-2">公司名称</label>
              <input type="text"
                class="w-full px-4 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-primary focus:border-primary">
            </div>
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-2">联系人</label>
              <input type="text"
                class="w-full px-4 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-primary focus:border-primary">
            </div>
          </div>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-2">联系电话</label>
              <input type="tel"
                class="w-full px-4 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-primary focus:border-primary">
            </div>
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-2">电子邮箱</label>
              <input type="email"
                class="w-full px-4 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-primary focus:border-primary">
            </div>
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">主营业务</label>
            <select
              class="w-full px-4 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-primary focus:border-primary">
              <option>视听设备</option>
              <option>会展家具</option>
              <option>搭建材料</option>
              <option>展示道具</option>
              <option>其他设备</option>
            </select>
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">公司简介</label>
            <textarea rows="4"
              class="w-full px-4 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-primary focus:border-primary"></textarea>
          </div>
          <div class="flex items-center">
            <input type="checkbox" class="w-4 h-4 text-primary border-gray-300 rounded focus:ring-primary"
              id="agreement">
            <label for="agreement" class="ml-2 text-sm text-gray-600">我已阅读并同意<a href="#"
                class="text-primary hover:text-secondary">《供应商服务协议》</a></label>
          </div>
          <button type="submit"
            class="w-full bg-primary text-white py-3 !rounded-button hover:bg-secondary transition-colors whitespace-nowrap">提交申请</button>
        </form>
      </div>
    </div>
  </section>

  <section class="py-16 px-6 lg:px-12">
    <div class="max-w-7xl mx-auto">
      <div class="text-center mb-12">
        <h2 class="text-3xl font-bold text-gray-900 mb-4">常见问题</h2>
        <p class="text-gray-600 text-lg">解答您关心的问题</p>
      </div>
      <div class="max-w-3xl mx-auto">
        <div class="space-y-4">
          <div class="border border-gray-200 rounded-lg">
            <button class="w-full px-6 py-4 text-left focus:outline-none">
              <div class="flex items-center justify-between">
                <h3 class="text-lg font-medium text-gray-900">加盟费用是多少？</h3>
                <div class="w-5 h-5 flex items-center justify-center">
                  <i class="ri-arrow-down-s-line text-gray-400"></i>
                </div>
              </div>
            </button>
            <div class="px-6 pb-4">
              <p class="text-gray-600">平台采用阶梯式收费标准，具体费用将根据您的业务规模和合作方式进行个性化定制，欢迎咨询了解详情。</p>
            </div>
          </div>
          <div class="border border-gray-200 rounded-lg">
            <button class="w-full px-6 py-4 text-left focus:outline-none">
              <div class="flex items-center justify-between">
                <h3 class="text-lg font-medium text-gray-900">如何保证订单安全？</h3>
                <div class="w-5 h-5 flex items-center justify-center">
                  <i class="ri-arrow-down-s-line text-gray-400"></i>
                </div>
              </div>
            </button>
            <div class="px-6 pb-4">
              <p class="text-gray-600">平台采用专业的订单管理系统和资金托管服务，确保交易安全。同时设有专门的客服团队，24小时处理订单相关问题。</p>
            </div>
          </div>
          <div class="border border-gray-200 rounded-lg">
            <button class="w-full px-6 py-4 text-left focus:outline-none">
              <div class="flex items-center justify-between">
                <h3 class="text-lg font-medium text-gray-900">平台提供哪些培训支持？</h3>
                <div class="w-5 h-5 flex items-center justify-center">
                  <i class="ri-arrow-down-s-line text-gray-400"></i>
                </div>
              </div>
            </button>
            <div class="px-6 pb-4">
              <p class="text-gray-600">平台提供系统使用培训、运营管理培训、市场营销培训等多方面支持，帮助供应商快速适应平台运营模式。</p>
            </div>
          </div>
          <div class="border border-gray-200 rounded-lg">
            <button class="w-full px-6 py-4 text-left focus:outline-none">
              <div class="flex items-center justify-between">
                <h3 class="text-lg font-medium text-gray-900">审核需要多长时间？</h3>
                <div class="w-5 h-5 flex items-center justify-center">
                  <i class="ri-arrow-down-s-line text-gray-400"></i>
                </div>
              </div>
            </button>
            <div class="px-6 pb-4">
              <p class="text-gray-600">正常情况下，资质审核周期为 3-5 个工作日。如资料完整且符合要求，可加快审核进度。</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="py-16 px-6 lg:px-12 bg-primary">
    <div class="max-w-7xl mx-auto text-center">
      <h2 class="text-3xl font-bold text-white mb-8">立即加入我们，开启事业新篇章</h2>
      <button
        class="bg-white text-primary px-8 py-3 !rounded-button hover:bg-gray-100 transition-colors text-lg whitespace-nowrap">联系我们</button>
    </div>
  </section>

    <!-- 使用公共页脚组件 -->
    <Footer />
  </div>
</template>

<script>
import Nav from "@/components/Nav.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "Join",
  components: {
    Nav,
    Footer,
  },
};
</script>

<style scoped>
/* 容器样式 */
.join-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

</style>



// WEBPACK FOOTER //
// src/pages/mainpage/Join.vue